module.exports = __webpack_public_path__ + "img/21.21dad473.png";